/** Utilidades de pantalla Catálogo; si se mueven las constantes (`catalogScreen.constants`), mover este archivo en paralelo. */
import { formatLocalDate } from '@shared/vueltoDateTime';
import { parseDecimalInput } from '../../shared/numeric/localeNumeric';
import type { Product } from '../domain/productTypes';

export const formatUpdatedAt = (value?: string | null) => {
  if (!value) return 'Sin datos';
  return formatLocalDate(value);
};

export const calculateMarginValue = (price: number, avgCost: number | null) => {
  if (avgCost == null || !Number.isFinite(price)) {
    return null;
  }

  return price - avgCost;
};

export const calculateMarginPercent = (price: number, marginValue: number | null) => {
  if (marginValue == null || !Number.isFinite(price) || price <= 0) {
    return null;
  }

  return (marginValue / price) * 100;
};

export const calculateSuggestedPrice = (avgCost: number | null, targetMarginPercentInput: string) => {
  const percentValue = parseDecimalInput(targetMarginPercentInput);
  const validPercent = percentValue != null && percentValue > 0 && percentValue < 100;

  if (avgCost == null || !validPercent) {
    return null;
  }

  return avgCost / (1 - percentValue / 100);
};

export const isProductActive = (product: Product | { isActive?: boolean | null }) => {
  return (product as { isActive?: boolean | null }).isActive ?? false;
};
